import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Link } from 'react-router-dom'
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ticon1 from "../../../images/icon/flower-icon-blue.svg";
import tImg1 from "../../../images/testimonial/da-tes-img.png";
import tImg2 from "../../../images/testimonial/ixico-logo.png";



const Testimonial = ({data}) => {

    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current && prevRef.current && nextRef.current) {
            swiperRef.current.params.navigation.prevEl = prevRef.current;
            swiperRef.current.params.navigation.nextEl = nextRef.current;
            swiperRef.current.navigation.init();
            swiperRef.current.navigation.update();
        }
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="testimonial pt-150 pb-140" id="portfolio">
            <div className="container">
                <div className="da-sec-titlte text-center mb-60">
                    <h2 className="title">مقالات</h2>
                </div>
                <div className="da-testimonial-wrap pos-rel">
                    <div className="da-testimonial-slider swiper-container">
                        <div className="swiper-wrapper">
                            <Swiper
                                // install Swiper modules
                                modules={[Navigation]}
                                spaceBetween={50}
                                slidesPerView={1}
                                loop={true}
                                speed={1800}
                                dir="rtl"
                                parallax={true}
                                ref={swiperRef}
                                autoplay={false}
                                onBeforeInit={(swiper) => {
                                    swiperRef.current = swiper;
                                }}
                            >
                                {data.map((item,key)=>{
                                    return(
                                        <SwiperSlide className="da-testimonial" key={key}>
                                    <div className="row align-items-start mt-none-30">
                                    <div className="col-lg-6 mt-30">
                                            <div className="da-tes-right">
                                                <div className="xb-item--author">
                                                    <img src={item.file_path} alt="" />
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mt-30">
                                            <div className="da-tes-left text-end">
                                                <h2 className="xb-item--title">{item.title}</h2>
                                                <p className="xb-item--content content--one">{item.summary}</p>
                                                <div className="xb-item--holder ul_li align-items-start justify-content-between">
                                                    <div className="xb-item--meta me-0 ">
                                                        {/* <h3 className="xb-item--number">$3 Million</h3> */}
                                                        <span className="text-justify text-over o7" dir="rtl" dangerouslySetInnerHTML={{__html: item.body}}></span>
                                                    </div>
                                                    {/* <div className="xb-item--meta">
                                                        <h3 className="xb-item--number">200+ Clinical Trials</h3>
                                                        <span className="xb-item--text">Supported globally with IXICO's AI-enhanced imaging biomarkers.</span>
                                                    </div> */}
                                                </div>
                                                {/* <p className="xb-item--content content--two">IXICO is a premium, specialist neuroimaging services provider to the global biopharmaceutical industry.</p> */}
                                                {/* <p className="xb-item--content content--three">The company develops and deploys therapeutic specific AI <br /> (Artificial  Intelligence) algorithms designed to reduce clinical trial <br /> size and  costs whilst simultaneously improving insights to increase the  likelihood of approval in neurological clinical trials.</p> */}
                                            </div>
                                        </div>
                                        
                                    </div>
                                </SwiperSlide>
                                    )
                                })}
                                
                               
                            </Swiper>
                        </div>
                    </div>
                    <div className="da-swiper-btn swiper-button-prev" ref={prevRef}><i className="fal fa-long-arrow-left"></i></div>
                    <div className="da-swiper-btn swiper-button-next" ref={nextRef}><i className="fal fa-long-arrow-right"></i></div>
                </div>
                <div className="xb-btn text-center mt-55">
                    {/* <Link onClick={ClickHandler} to="/contact" className="thm-btn thm-btn--fill_icon thm-btn--data thm-btn--data-strock">
                        <div className="xb-item--hidden"><span className="xb-item--hidden-text">View More Case Studies</span></div>
                        <div className="xb-item--holder">
                            <span className="xb-item--text xb-item--text1">View More Case Studies</span>
                            <div className="xb-item--icon"><i className="fal fa-plus"></i></div>
                            <span className="xb-item--text xb-item--text2">View More Case Studies</span>
                        </div>
                    </Link> */}
                </div>
            </div>
        </section>
    );
};

export default Testimonial;
